import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../../services/cashService';

export const useGetWithdrawHistory = params => {
  return useQuery({
    queryKey: [QUERY_KEYS.cash.withdraw_history, params],
    queryFn: () =>
      cashService.withdrawHistory(params).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
